export default {
  scene: {
    background: 0x7e5979,
    shadow: 0xd190c8,
    fog: {
      color: 0x7e5979,
      near: 50,
      far: 300
    }
  },
  environment: {
    rotation: Math.PI / 2,
    position: {
      x: 0,
      y: -5.1,
      z: 0
    }
  },
  character: {
    timeScale: 1.0,
    rotation: Math.PI / 2,
    position: {
      x: -14,
      y: -5,
      z: 5.5
    }
  },
  player: {
    timeScale: 1.1,
    rotation: Math.PI / 2,
    position: {
      x: -12,
      y: -5,
      z: -1
    }
  },
  speed: 3
}
